import styled from "styled-components";
import { IGrid } from "./Grid.interface";
import { sm, md, lg, xlg } from "../../../AppTheme.styled";

const StyledGrid = styled.div<IGrid>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  gap: 8px;

  ${sm} {
    gap: 24px;
  }
  ${md} {
    gap: 32px;
  }
  ${lg} {
    gap: 32px;
  }
  ${xlg} {
    gap: 40px;
  }
`;

export default StyledGrid;
